import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explainer-video',
  templateUrl: './explainer-video.component.html',
  styleUrls: ['./explainer-video.component.css']
})
export class ExplainerVideoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
